import React from 'react'
import { Outlet } from 'react-router-dom'

function MainEquipDetails() {
  return (
    <div>
      <Outlet/>
    </div>
  )
}

export default MainEquipDetails
